import { render, staticRenderFns } from "./HomeworkEmptyState.vue?vue&type=template&id=7a97fef9&scoped=true&"
import script from "./HomeworkEmptyState.vue?vue&type=script&lang=js&"
export * from "./HomeworkEmptyState.vue?vue&type=script&lang=js&"
import style0 from "./HomeworkEmptyState.vue?vue&type=style&index=0&id=7a97fef9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a97fef9",
  null
  
)

export default component.exports